import { CreatorProductModule } from './CreatorProductModuleApi';
import { Attachment, UUID } from '@/types/types';
import { ProductModuleCollection } from './ProductModuleCollectionApi';
import { QueryKey } from '@/configs/queryKeys';
import { SerializedRenderer } from '@/renderer/types';
import EntityApi, { BaseEntity } from './EntityApi';
import httpClient from './httpClient';

export enum PresetStatus {
	ACTIVE = 'ACTIVE',
	INACTIVE = 'INACTIVE',
}

export interface Preset extends BaseEntity {
	name: string;
	image?: Attachment;
	creatorProductModules: CreatorProductModule[];
	productModuleCollection?: ProductModuleCollection;
	listOrder: number;
	price: number;
	status: PresetStatus;
	options: {
		renderer?: SerializedRenderer;
	};
}

class PresetApi extends EntityApi<Preset> {
	constructor() {
		super(QueryKey.presets);
		this.clear = this.clear.bind(this);
	}

	async clear(id: UUID) {
		const response = await httpClient.patch<Preset>(
			`${this.queryKey}/${id}/clear`
		);
		return response.data;
	}
}

export default new PresetApi();
